import React from "react";

interface IconProps {
  active?: boolean;
  color?: string; // Optional parameter for color (default: #004B8B)
}
interface LogoProps extends IconProps {
  height?: number;
  width?: number;
}
export const DashBoardIcon: React.FC<IconProps> = ({
  active = false,
  color = "#004B8B",
}) => {
  return active ? (
    <div>
      <svg
        width="40"
        height="40"
        viewBox="0 0 40 40"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M13 9C10.7909 9 9 10.7909 9 13V22.2754C9 24.4846 10.7909 26.2754 13 26.2754H27.2113C29.4204 26.2754 31.2113 24.4846 31.2113 22.2754V13C31.2113 10.7909 29.4204 9 27.2113 9H13ZM26.9129 15.31C27.2282 14.9257 27.1723 14.3586 26.7881 14.0433C26.4038 13.728 25.8367 13.7839 25.5214 14.1682L22.4274 17.9389L18.9158 15.3218L18.2271 14.8085L17.6822 15.4725L14.0433 19.9072C13.728 20.2915 13.7839 20.8586 14.1682 21.1739C14.5524 21.4892 15.1195 21.4333 15.4348 21.049L18.5289 17.2783L22.0405 19.8954L22.7292 20.4087L23.274 19.7447L26.9129 15.31Z"
          fill={color}
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M20.1059 24.3714C20.5732 24.3714 20.9521 24.7502 20.9521 25.2175L20.9521 30.1534C20.9521 30.6207 20.5732 30.9995 20.1059 30.9995C19.6386 30.9995 19.2598 30.6207 19.2598 30.1534L19.2598 25.2175C19.2598 24.7502 19.6386 24.3714 20.1059 24.3714Z"
          fill={color}
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M24.6533 30.1533C24.6533 30.6206 24.2745 30.9994 23.8072 30.9994H16.4034C15.9361 30.9994 15.5573 30.6206 15.5573 30.1533C15.5573 29.686 15.9361 29.3071 16.4034 29.3071H23.8072C24.2745 29.3071 24.6533 29.686 24.6533 30.1533Z"
          fill={color}
        />
      </svg>
    </div>
  ) : (
    <div>
      <svg
        width="40"
        height="40"
        viewBox="0 0 40 40"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M13 9C10.7909 9 9 10.7909 9 13V22.2754C9 24.4846 10.7909 26.2754 13 26.2754H27.2113C29.4204 26.2754 31.2113 24.4846 31.2113 22.2754V13C31.2113 10.7909 29.4204 9 27.2113 9H13ZM26.9129 15.31C27.2282 14.9257 27.1723 14.3586 26.7881 14.0433C26.4038 13.728 25.8367 13.7839 25.5214 14.1682L22.4274 17.9389L18.9158 15.3218L18.2271 14.8085L17.6822 15.4725L14.0433 19.9072C13.728 20.2915 13.7839 20.8586 14.1682 21.1739C14.5524 21.4892 15.1195 21.4333 15.4348 21.049L18.5289 17.2783L22.0405 19.8954L22.7292 20.4087L23.274 19.7447L26.9129 15.31Z"
          fill={`${color}40`}
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M20.1059 24.3714C20.5732 24.3714 20.9521 24.7502 20.9521 25.2175L20.9521 30.1534C20.9521 30.6207 20.5732 30.9995 20.1059 30.9995C19.6386 30.9995 19.2598 30.6207 19.2598 30.1534L19.2598 25.2175C19.2598 24.7502 19.6386 24.3714 20.1059 24.3714Z"
          fill={`${color}40`}
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M24.6533 30.1533C24.6533 30.6206 24.2745 30.9994 23.8072 30.9994H16.4034C15.9361 30.9994 15.5573 30.6206 15.5573 30.1533C15.5573 29.686 15.9361 29.3071 16.4034 29.3071H23.8072C24.2745 29.3071 24.6533 29.686 24.6533 30.1533Z"
          fill={`${color}40`}
        />
      </svg>
    </div>
  );
};

export const PartiesIcon: React.FC<IconProps> = ({
  active = false,
  color = "#004B8B",
}) => {
  return active ? (
    <div>
      <svg
        width="40"
        height="40"
        viewBox="0 0 40 40"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <circle cx="19.9992" cy="13.9592" r="4.95919" fill={color} />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M10.0057 29.3375C10.1005 26.3715 11.3868 20.5713 19.9995 20.5713C28.6122 20.5713 29.8987 26.3714 29.9935 29.3374C30.025 30.3211 29.1932 31.0407 28.209 31.0407H11.7903C10.8061 31.0407 9.97433 30.3211 10.0057 29.3375ZM18.3463 27.0911L19.7307 21.3245C19.7955 21.0546 20.2033 21.0546 20.2681 21.3245L21.6524 27.0911L19.9994 28.8363L18.3463 27.0911Z"
          fill={color}
        />
      </svg>
    </div>
  ) : (
    <div>
      <svg
        width="40"
        height="40"
        viewBox="0 0 40 40"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <circle cx="19.9992" cy="13.9592" r="4.95919" fill={`${color}40`} />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M10.0057 29.3375C10.1005 26.3715 11.3868 20.5713 19.9995 20.5713C28.6122 20.5713 29.8987 26.3714 29.9935 29.3374C30.025 30.3211 29.1932 31.0407 28.209 31.0407H11.7903C10.8061 31.0407 9.97433 30.3211 10.0057 29.3375ZM18.3463 27.0911L19.7307 21.3245C19.7955 21.0546 20.2033 21.0546 20.2681 21.3245L21.6524 27.0911L19.9994 28.8363L18.3463 27.0911Z"
          fill={`${color}40`}
        />
      </svg>
    </div>
  );
};

export const ItemIcon: React.FC<IconProps> = ({
  active = false,
  color = "#004B8B",
}) => {
  return active ? (
    <div>
      <svg
        width="40"
        height="40"
        viewBox="0 0 40 40"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M21.9724 9.52023C20.7489 8.82675 19.2511 8.82675 18.0276 9.52023L15 11.2363L12.0001 13.0002C10.7877 13.7131 10.0388 15.0102 10.0277 16.4165L10 19.8965L10.0277 23.3765C10.0388 24.7828 10.7877 26.08 12.0001 26.7928L15 28.5568L18.0276 30.2728C19.2511 30.9663 20.7489 30.9663 21.9724 30.2728L25 28.5568L27.9999 26.7928C29.2123 26.08 29.9612 24.7828 29.9723 23.3765L30 19.8965L29.9723 16.4165C29.9612 15.0102 29.2123 13.7131 27.9999 13.0002L25 11.2363L21.9724 9.52023ZM14.691 15.8788C14.3237 15.6686 13.8555 15.7959 13.6453 16.1632C13.4351 16.5305 13.5624 16.9987 13.9297 17.2089L18.8984 20.0528C19.2097 20.231 19.4017 20.5621 19.4017 20.9207V26.6014C19.4017 27.0246 19.7447 27.3676 20.168 27.3676C20.5912 27.3676 20.9342 27.0246 20.9342 26.6014V20.9011C20.9342 20.5485 21.12 20.2219 21.423 20.0416L26.1963 17.2025C26.5601 16.9861 26.6796 16.5159 26.4632 16.1522C26.2469 15.7884 25.7766 15.669 25.4129 15.8853L20.662 18.7111C20.3522 18.8954 19.967 18.8986 19.6541 18.7195L14.691 15.8788Z"
          fill={color}
        />
      </svg>
    </div>
  ) : (
    <>
      <div>
        <svg
          width="40"
          height="40"
          viewBox="0 0 40 40"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M21.9724 9.52023C20.7489 8.82675 19.2511 8.82675 18.0276 9.52023L15 11.2363L12.0001 13.0002C10.7877 13.7131 10.0388 15.0102 10.0277 16.4165L10 19.8965L10.0277 23.3765C10.0388 24.7828 10.7877 26.08 12.0001 26.7928L15 28.5568L18.0276 30.2728C19.2511 30.9663 20.7489 30.9663 21.9724 30.2728L25 28.5568L27.9999 26.7928C29.2123 26.08 29.9612 24.7828 29.9723 23.3765L30 19.8965L29.9723 16.4165C29.9612 15.0102 29.2123 13.7131 27.9999 13.0002L25 11.2363L21.9724 9.52023ZM14.691 15.8788C14.3237 15.6686 13.8555 15.7959 13.6453 16.1632C13.4351 16.5305 13.5624 16.9987 13.9297 17.2089L18.8984 20.0528C19.2097 20.231 19.4017 20.5621 19.4017 20.9207V26.6014C19.4017 27.0246 19.7447 27.3676 20.168 27.3676C20.5912 27.3676 20.9342 27.0246 20.9342 26.6014V20.9011C20.9342 20.5485 21.12 20.2219 21.423 20.0416L26.1963 17.2025C26.5601 16.9861 26.6796 16.5159 26.4632 16.1522C26.2469 15.7884 25.7766 15.669 25.4129 15.8853L20.662 18.7111C20.3522 18.8954 19.967 18.8986 19.6541 18.7195L14.691 15.8788Z"
            fill={`${color}40`}
          />
        </svg>
      </div>
    </>
  );
};

export const SalesIcon: React.FC<IconProps> = ({
  active = false,
  color = "#004B8B",
}) => {
  return active ? (
    <div>
      <svg
        width="40"
        height="40"
        viewBox="0 0 40 40"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M13.5 17L12.7785 12.6712C12.6178 11.7068 11.7834 11 10.8057 11H10"
          stroke={color}
          stroke-width="2"
          stroke-linecap="round"
        />
        <circle cx="17" cy="30" r="1" fill={color} />
        <circle cx="27" cy="30" r="1" fill={color} />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M28.541 13.9999H12L13.632 25.4241C13.8432 26.9021 15.1089 27.9999 16.6019 27.9999H27.3981C28.8911 27.9999 30.1568 26.9021 30.368 25.4241L31.5108 17.4241C31.769 15.6168 30.3666 13.9999 28.541 13.9999ZM22.8 15.9998C22.3582 15.9998 22 16.3579 22 16.7998C22 17.2416 22.3582 17.5998 22.8 17.5998H28.3C28.7418 17.5998 29.1 17.2416 29.1 16.7998C29.1 16.3579 28.7418 15.9998 28.3 15.9998H22.8Z"
          fill={color}
        />
      </svg>
    </div>
  ) : (
    <div>
      <svg
        width="40"
        height="40"
        viewBox="0 0 40 40"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M13.5 17L12.7785 12.6712C12.6178 11.7068 11.7834 11 10.8057 11H10"
          stroke={`${color}40`}
          stroke-width="2"
          stroke-linecap="round"
        />
        <circle cx="17" cy="30" r="1" fill={`${color}40`} />
        <circle cx="27" cy="30" r="1" fill={`${color}40`} />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M28.541 13.9999H12L13.632 25.4241C13.8432 26.9021 15.1089 27.9999 16.6019 27.9999H27.3981C28.8911 27.9999 30.1568 26.9021 30.368 25.4241L31.5108 17.4241C31.769 15.6168 30.3666 13.9999 28.541 13.9999ZM22.8 15.9998C22.3582 15.9998 22 16.3579 22 16.7998C22 17.2416 22.3582 17.5998 22.8 17.5998H28.3C28.7418 17.5998 29.1 17.2416 29.1 16.7998C29.1 16.3579 28.7418 15.9998 28.3 15.9998H22.8Z"
          fill={`${color}40`}
        />
      </svg>
    </div>
  );
};

export const PurchaseIcon: React.FC<IconProps> = ({
  active = false,
  color = "#004B8B",
}) => {
  return active ? (
    <div>
      <svg
        width="40"
        height="40"
        viewBox="0 0 40 40"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M16.6628 16.8916H16.7628V16.7916V11.1854C16.7628 10.1851 17.5737 9.37415 18.574 9.37415H21.9745C22.9748 9.37415 23.7857 10.1851 23.7857 11.1854V16.7916V16.8916H23.8857H25.1598H25.2598V16.7916V11.1854C25.2598 9.37091 23.7889 7.9 21.9745 7.9H18.574C16.7596 7.9 15.2887 9.37091 15.2887 11.1854V16.7916V16.8916H15.3887H16.6628Z"
          fill={color}
          stroke={color}
          stroke-width="0.2"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M13.6444 14.7528C12.0602 14.7528 10.7491 15.9846 10.6503 17.5657L10.006 27.8747C9.89802 29.6018 11.2697 31.0619 13.0001 31.0619H26.9997C28.7302 31.0619 30.1018 29.6018 29.9939 27.8747L29.3496 17.5657C29.2508 15.9846 27.9396 14.7528 26.3554 14.7528H13.6444ZM25.0931 21.1339C25.4152 20.8192 25.4212 20.3029 25.1065 19.9807C24.7918 19.6586 24.2755 19.6526 23.9534 19.9673L18.9874 24.8192L16.4994 22.3312C16.1809 22.0127 15.6646 22.0127 15.3461 22.3312C15.0277 22.6496 15.0277 23.1659 15.3461 23.4844L18.974 27.1123L25.0931 21.1339Z"
          fill={color}
        />
        <ellipse
          cx="16.1141"
          cy="16.3461"
          rx="0.701047"
          ry="0.701047"
          fill={color}
        />
        <ellipse
          cx="24.5233"
          cy="16.3461"
          rx="0.701047"
          ry="0.701047"
          fill={color}
        />
      </svg>
    </div>
  ) : (
    <div>
      <svg
        width="40"
        height="40"
        viewBox="0 0 40 40"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M16.6628 16.8916H16.7628V16.7916V11.1854C16.7628 10.1851 17.5737 9.37415 18.574 9.37415H21.9745C22.9748 9.37415 23.7857 10.1851 23.7857 11.1854V16.7916V16.8916H23.8857H25.1598H25.2598V16.7916V11.1854C25.2598 9.37091 23.7889 7.9 21.9745 7.9H18.574C16.7596 7.9 15.2887 9.37091 15.2887 11.1854V16.7916V16.8916H15.3887H16.6628Z"
          fill={`${color}40`}
          stroke={`${color}40`}
          stroke-width="0.2"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M13.6444 14.7528C12.0602 14.7528 10.7491 15.9846 10.6503 17.5657L10.006 27.8747C9.89802 29.6018 11.2697 31.0619 13.0001 31.0619H26.9997C28.7302 31.0619 30.1018 29.6018 29.9939 27.8747L29.3496 17.5657C29.2508 15.9846 27.9396 14.7528 26.3554 14.7528H13.6444ZM25.0931 21.1339C25.4152 20.8192 25.4212 20.3029 25.1065 19.9807C24.7918 19.6586 24.2755 19.6526 23.9534 19.9673L18.9874 24.8192L16.4994 22.3312C16.1809 22.0127 15.6646 22.0127 15.3461 22.3312C15.0277 22.6496 15.0277 23.1659 15.3461 23.4844L18.974 27.1123L25.0931 21.1339Z"
          fill={`${color}40`}
        />
        <ellipse
          cx="16.1141"
          cy="16.3461"
          rx="0.701047"
          ry="0.701047"
          fill={`${color}40`}
        />
        <ellipse
          cx="24.5233"
          cy="16.3461"
          rx="0.701047"
          ry="0.701047"
          fill={`${color}40`}
        />
      </svg>
    </div>
  );
};

export const ExpndIncIcon: React.FC<IconProps> = ({
  active = false,
  color = "#004B8B",
}) => {
  return active ? (
    <div>
      <svg
        width="40"
        height="40"
        viewBox="0 0 40 40"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M-nan -nanL22 20C22 18.8954 22.8954 18 24 18H30V22H24C22.8954 22 22 21.1046 22 20L-nan -nanZ"
          fill={color}
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M14 10C11.7909 10 10 11.7909 10 14V26C10 28.2091 11.7909 30 14 30H26C28.2091 30 30 28.2091 30 26V23.5999H24C22.0118 23.5999 20.4 21.9881 20.4 19.9999C20.4 18.0117 22.0118 16.3999 24 16.3999H30V14C30 11.7909 28.2091 10 26 10H14ZM30 17.9999H24C22.8955 17.9999 22 18.8953 22 19.9999C22 21.1045 22.8955 21.9999 24 21.9999H30V17.9999ZM24 21C24.5523 21 25 20.5523 25 20C25 19.4477 24.5523 19 24 19C23.4477 19 23 19.4477 23 20C23 20.5523 23.4477 21 24 21ZM12 13C12 12.4477 12.4477 12 13 12H17C17.5523 12 18 12.4477 18 13C18 13.5523 17.5523 14 17 14H13C12.4477 14 12 13.5523 12 13Z"
          fill={color}
        />
      </svg>
    </div>
  ) : (
    <div>
      <svg
        width="40"
        height="40"
        viewBox="0 0 40 40"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M-nan -nanL22 20C22 18.8954 22.8954 18 24 18H30V22H24C22.8954 22 22 21.1046 22 20L-nan -nanZ"
          fill={`${color}40`}
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M14 10C11.7909 10 10 11.7909 10 14V26C10 28.2091 11.7909 30 14 30H26C28.2091 30 30 28.2091 30 26V23.5999H24C22.0118 23.5999 20.4 21.9881 20.4 19.9999C20.4 18.0117 22.0118 16.3999 24 16.3999H30V14C30 11.7909 28.2091 10 26 10H14ZM30 17.9999H24C22.8955 17.9999 22 18.8953 22 19.9999C22 21.1045 22.8955 21.9999 24 21.9999H30V17.9999ZM24 21C24.5523 21 25 20.5523 25 20C25 19.4477 24.5523 19 24 19C23.4477 19 23 19.4477 23 20C23 20.5523 23.4477 21 24 21ZM12 13C12 12.4477 12.4477 12 13 12H17C17.5523 12 18 12.4477 18 13C18 13.5523 17.5523 14 17 14H13C12.4477 14 12 13.5523 12 13Z"
          fill={`${color}40`}
        />
      </svg>
    </div>
  );
};

export const CashndBankIcon: React.FC<IconProps> = ({
  active = false,
  color = "#004B8B",
}) => {
  return active ? (
    <div>
      <svg
        width="40"
        height="40"
        viewBox="0 0 40 40"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <rect
          x="11.4141"
          y="17.4237"
          width="4.31062"
          height="9.93162"
          fill={color}
        />
        <rect
          x="17.8799"
          y="17.4237"
          width="4.31062"
          height="9.93162"
          fill={color}
        />
        <path
          d="M28.6562 26.019C29.8466 26.019 30.8115 26.984 30.8115 28.1744C30.8115 29.3647 29.8466 30.3297 28.6562 30.3297L11.4137 30.3297C10.2234 30.3297 9.25841 29.3647 9.25841 28.1744C9.25841 26.984 10.2234 26.019 11.4137 26.019L28.6562 26.019Z"
          fill={color}
        />
        <rect
          x="24.3457"
          y="17.4237"
          width="4.31062"
          height="9.93162"
          fill={color}
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M22.7947 9.99911C21.1961 8.66696 18.8741 8.66696 17.2755 9.99911L9.38991 16.5705C8.61559 17.2157 9.07188 18.476 10.0798 18.476H29.9905C30.9984 18.476 31.4547 17.2157 30.6804 16.5705L22.7947 9.99911ZM20.2999 16.496C20.9094 16.496 21.4034 16.0019 21.4034 15.3925C21.4034 14.783 20.9094 14.289 20.2999 14.289C19.6904 14.289 19.1964 14.783 19.1964 15.3925C19.1964 16.0019 19.6904 16.496 20.2999 16.496Z"
          fill={color}
        />
      </svg>
    </div>
  ) : (
    <div>
      <svg
        width="40"
        height="40"
        viewBox="0 0 40 40"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <rect
          x="11.4141"
          y="17.4237"
          width="4.31062"
          height="9.93162"
          fill={`${color}40`}
        />
        <rect
          x="17.8799"
          y="17.4237"
          width="4.31062"
          height="9.93162"
          fill={`${color}40`}
        />
        <path
          d="M28.6562 26.019C29.8466 26.019 30.8115 26.984 30.8115 28.1744C30.8115 29.3647 29.8466 30.3297 28.6562 30.3297L11.4137 30.3297C10.2234 30.3297 9.25841 29.3647 9.25841 28.1744C9.25841 26.984 10.2234 26.019 11.4137 26.019L28.6562 26.019Z"
          fill={`${color}40`}
        />
        <rect
          x="24.3457"
          y="17.4237"
          width="4.31062"
          height="9.93162"
          fill={`${color}40`}
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M22.7947 9.99911C21.1961 8.66696 18.8741 8.66696 17.2755 9.99911L9.38991 16.5705C8.61559 17.2157 9.07188 18.476 10.0798 18.476H29.9905C30.9984 18.476 31.4547 17.2157 30.6804 16.5705L22.7947 9.99911ZM20.2999 16.496C20.9094 16.496 21.4034 16.0019 21.4034 15.3925C21.4034 14.783 20.9094 14.289 20.2999 14.289C19.6904 14.289 19.1964 14.783 19.1964 15.3925C19.1964 16.0019 19.6904 16.496 20.2999 16.496Z"
          fill={`${color}40`}
        />
      </svg>
    </div>
  );
};

export const RegIcon: React.FC<IconProps> = ({
  active = false,
  color = "#004B8B",
}) => {
  return active ? (
    <div>
      <svg
        width="40"
        height="40"
        viewBox="0 0 40 40"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M11 13C11 10.7909 12.7909 9 15 9H25C27.2091 9 29 10.7909 29 13V20.4062C29 21.4503 28.5918 22.453 27.8626 23.2001L23.867 27.2939C23.1143 28.0651 22.0821 28.5 21.0044 28.5H15C12.7909 28.5 11 26.7091 11 24.5V13ZM14.2943 17.3752C14.2943 16.8818 14.6942 16.4818 15.1876 16.4818H24.9588C25.4522 16.4818 25.8522 16.8818 25.8522 17.3752C25.8522 17.8686 25.4522 18.2686 24.9588 18.2686H15.1876C14.6942 18.2686 14.2943 17.8686 14.2943 17.3752ZM15.3959 12.1421C14.9025 12.1421 14.5025 12.542 14.5025 13.0354C14.5025 13.5288 14.9025 13.9288 15.3959 13.9288H21.3959C21.8893 13.9288 22.2892 13.5288 22.2892 13.0354C22.2892 12.542 21.8893 12.1421 21.3959 12.1421H15.3959Z"
          fill={color}
        />
        <path
          d="M29.744 22.7158C30.1297 22.3205 30.7628 22.3127 31.1581 22.6983L31.6495 23.1777C32.0448 23.5634 32.0526 24.1965 31.6669 24.5918L25.2021 31.218L22.9615 31.591L23.2792 29.3419L29.744 22.7158Z"
          fill={color}
        />
      </svg>
    </div>
  ) : (
    <div>
      <svg
        width="40"
        height="40"
        viewBox="0 0 40 40"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M11 13C11 10.7909 12.7909 9 15 9H25C27.2091 9 29 10.7909 29 13V20.4062C29 21.4503 28.5918 22.453 27.8626 23.2001L23.867 27.2939C23.1143 28.0651 22.0821 28.5 21.0044 28.5H15C12.7909 28.5 11 26.7091 11 24.5V13ZM14.2943 17.3752C14.2943 16.8818 14.6942 16.4818 15.1876 16.4818H24.9588C25.4522 16.4818 25.8522 16.8818 25.8522 17.3752C25.8522 17.8686 25.4522 18.2686 24.9588 18.2686H15.1876C14.6942 18.2686 14.2943 17.8686 14.2943 17.3752ZM15.3959 12.1421C14.9025 12.1421 14.5025 12.542 14.5025 13.0354C14.5025 13.5288 14.9025 13.9288 15.3959 13.9288H21.3959C21.8893 13.9288 22.2892 13.5288 22.2892 13.0354C22.2892 12.542 21.8893 12.1421 21.3959 12.1421H15.3959Z"
          fill={`${color}40`}
        />
        <path
          d="M29.744 22.7158C30.1297 22.3205 30.7628 22.3127 31.1581 22.6983L31.6495 23.1777C32.0448 23.5634 32.0526 24.1965 31.6669 24.5918L25.2021 31.218L22.9615 31.591L23.2792 29.3419L29.744 22.7158Z"
          fill={`${color}40`}
        />
      </svg>
    </div>
  );
};

export const RepIcon: React.FC<IconProps> = ({
  active = false,
  color = "#004B8B",
}) => {
  return active ? (
    <div>
      <svg
        width="40"
        height="40"
        viewBox="0 0 40 40"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M13.5 9.26697C11.567 9.26697 10 10.834 10 12.767V26.0488C10 28.2387 11.761 30.0215 13.9508 30.0485L25.9508 30.196C28.179 30.2234 30 28.4247 30 26.1963V12.267C30 10.6101 28.6569 9.26697 27 9.26697H26.45C26.3395 9.26697 26.25 9.35651 26.25 9.46697C26.25 10.4611 25.4441 11.267 24.45 11.267H16.175C15.1809 11.267 14.375 10.4611 14.375 9.46697C14.375 9.35651 14.2855 9.26697 14.175 9.26697H13.5ZM26.7325 16.8419C27.1607 16.4374 27.18 15.7623 26.7755 15.3341C26.371 14.9058 25.6959 14.8865 25.2677 15.291L20.9804 19.34L19.3861 17.8343C18.8723 17.349 18.069 17.349 17.5551 17.8343L14.601 20.6243C14.1727 21.0288 14.1534 21.7039 14.5579 22.1322C14.9624 22.5605 15.6375 22.5798 16.0658 22.1753L18.4706 19.904L20.0649 21.4098C20.5788 21.8951 21.3821 21.8951 21.8959 21.4098L26.7325 16.8419Z"
          fill={color}
        />
        <path
          d="M16.667 9H24.0003"
          stroke={color}
          stroke-width="1.6"
          stroke-linecap="round"
        />
      </svg>
    </div>
  ) : (
    <div>
      <svg
        width="40"
        height="40"
        viewBox="0 0 40 40"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M13.5 9.26697C11.567 9.26697 10 10.834 10 12.767V26.0488C10 28.2387 11.761 30.0215 13.9508 30.0485L25.9508 30.196C28.179 30.2234 30 28.4247 30 26.1963V12.267C30 10.6101 28.6569 9.26697 27 9.26697H26.45C26.3395 9.26697 26.25 9.35651 26.25 9.46697C26.25 10.4611 25.4441 11.267 24.45 11.267H16.175C15.1809 11.267 14.375 10.4611 14.375 9.46697C14.375 9.35651 14.2855 9.26697 14.175 9.26697H13.5ZM26.7325 16.8419C27.1607 16.4374 27.18 15.7623 26.7755 15.3341C26.371 14.9058 25.6959 14.8865 25.2677 15.291L20.9804 19.34L19.3861 17.8343C18.8723 17.349 18.069 17.349 17.5551 17.8343L14.601 20.6243C14.1727 21.0288 14.1534 21.7039 14.5579 22.1322C14.9624 22.5605 15.6375 22.5798 16.0658 22.1753L18.4706 19.904L20.0649 21.4098C20.5788 21.8951 21.3821 21.8951 21.8959 21.4098L26.7325 16.8419Z"
          fill={`${color}40`}
        />
        <path
          d="M16.667 9H24.0003"
          stroke={`${color}40`}
          stroke-width="1.6"
          stroke-linecap="round"
        />
      </svg>
    </div>
  );
};

export const MasterIcon: React.FC<IconProps> = ({
  active = false,
  color = "#004B8B",
}) => {
  return active ? (
    <div>
      <svg
        width="40"
        height="40"
        viewBox="0 0 40 40"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M13.5 9.26697C11.567 9.26697 10 10.834 10 12.767V26.0488C10 28.2387 11.761 30.0215 13.9508 30.0485L25.9508 30.196C28.179 30.2234 30 28.4247 30 26.1963V12.267C30 10.6101 28.6569 9.26697 27 9.26697H26.45C26.3395 9.26697 26.25 9.35651 26.25 9.46697C26.25 10.4611 25.4441 11.267 24.45 11.267H16.175C15.1809 11.267 14.375 10.4611 14.375 9.46697C14.375 9.35651 14.2855 9.26697 14.175 9.26697H13.5ZM26.7325 16.8419C27.1607 16.4374 27.18 15.7623 26.7755 15.3341C26.371 14.9058 25.6959 14.8865 25.2677 15.291L20.9804 19.34L19.3861 17.8343C18.8723 17.349 18.069 17.349 17.5551 17.8343L14.601 20.6243C14.1727 21.0288 14.1534 21.7039 14.5579 22.1322C14.9624 22.5605 15.6375 22.5798 16.0658 22.1753L18.4706 19.904L20.0649 21.4098C20.5788 21.8951 21.3821 21.8951 21.8959 21.4098L26.7325 16.8419Z"
          fill={color}
        />
        <path
          d="M16.667 9H24.0003"
          stroke={color}
          stroke-width="1.6"
          stroke-linecap="round"
        />
      </svg>
    </div>
  ) : (
    <div>
      <svg
        width="40"
        height="40"
        viewBox="0 0 40 40"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M13.5 9.26697C11.567 9.26697 10 10.834 10 12.767V26.0488C10 28.2387 11.761 30.0215 13.9508 30.0485L25.9508 30.196C28.179 30.2234 30 28.4247 30 26.1963V12.267C30 10.6101 28.6569 9.26697 27 9.26697H26.45C26.3395 9.26697 26.25 9.35651 26.25 9.46697C26.25 10.4611 25.4441 11.267 24.45 11.267H16.175C15.1809 11.267 14.375 10.4611 14.375 9.46697C14.375 9.35651 14.2855 9.26697 14.175 9.26697H13.5ZM26.7325 16.8419C27.1607 16.4374 27.18 15.7623 26.7755 15.3341C26.371 14.9058 25.6959 14.8865 25.2677 15.291L20.9804 19.34L19.3861 17.8343C18.8723 17.349 18.069 17.349 17.5551 17.8343L14.601 20.6243C14.1727 21.0288 14.1534 21.7039 14.5579 22.1322C14.9624 22.5605 15.6375 22.5798 16.0658 22.1753L18.4706 19.904L20.0649 21.4098C20.5788 21.8951 21.3821 21.8951 21.8959 21.4098L26.7325 16.8419Z"
          fill={`${color}40`}
        />
        <path
          d="M16.667 9H24.0003"
          stroke={`${color}40`}
          stroke-width="1.6"
          stroke-linecap="round"
        />
      </svg>
    </div>
  );
};

export const SettingIcon: React.FC<IconProps> = ({
  active = false,
  color = "#004B8B",
}) => {
  return active ? (
    <div>
      <svg
        width="40"
        height="40"
        viewBox="0 0 40 40"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M21.0191 9C21.4688 9 21.8333 9.36454 21.8333 9.81422C21.8333 11.6866 24.1481 12.5658 25.3912 11.1656C25.6897 10.8293 26.2043 10.7987 26.5406 11.0972L27.9426 12.3418C28.3464 12.7003 28.3831 13.3183 28.0246 13.7221L27.6897 14.0994C26.29 15.6762 27.4093 18.1667 29.5178 18.1667H30.0222C30.5622 18.1667 31 18.6044 31 19.1444V20.8989C31 21.415 30.5817 21.8333 30.0656 21.8333C27.9845 21.8333 26.9423 24.3495 28.4139 25.8211C28.7788 26.186 28.7788 26.7776 28.4139 27.1425L27.1426 28.4138C26.7777 28.7787 26.1861 28.7787 25.8212 28.4138C24.3496 26.9422 21.8333 27.9844 21.8333 30.0656C21.8333 30.5817 21.415 31 20.8989 31H18.9809C18.5312 31 18.1667 30.6355 18.1667 30.1858C18.1667 28.3134 15.8519 27.4342 14.6088 28.8344C14.3103 29.1707 13.7957 29.2013 13.4594 28.9027L12.0575 27.6582C11.6536 27.2997 11.6169 26.6817 11.9754 26.2778L12.3102 25.9006C13.71 24.3238 12.5906 21.8333 10.4822 21.8333H9.97778C9.43777 21.8333 9 21.3956 9 20.8556V19.1011C9 18.585 9.41835 18.1667 9.93441 18.1667C12.0155 18.1667 13.0578 15.6505 11.5862 14.1789C11.2213 13.814 11.2213 13.2224 11.5862 12.8575L12.8576 11.5862C13.2225 11.2213 13.8141 11.2213 14.179 11.5862C15.6505 13.0577 18.1667 12.0155 18.1667 9.93439C18.1667 9.41834 18.585 9 19.1011 9H21.0191ZM20 23.3C21.8225 23.3 23.3 21.8225 23.3 20C23.3 18.1775 21.8225 16.7 20 16.7C18.1775 16.7 16.7 18.1775 16.7 20C16.7 21.8225 18.1775 23.3 20 23.3Z"
          fill={color}
        />
      </svg>
    </div>
  ) : (
    <div>
      <svg
        width="40"
        height="40"
        viewBox="0 0 40 40"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M21.0191 9C21.4688 9 21.8333 9.36454 21.8333 9.81422C21.8333 11.6866 24.1481 12.5658 25.3912 11.1656C25.6897 10.8293 26.2043 10.7987 26.5406 11.0972L27.9426 12.3418C28.3464 12.7003 28.3831 13.3183 28.0246 13.7221L27.6897 14.0994C26.29 15.6762 27.4093 18.1667 29.5178 18.1667H30.0222C30.5622 18.1667 31 18.6044 31 19.1444V20.8989C31 21.415 30.5817 21.8333 30.0656 21.8333C27.9845 21.8333 26.9423 24.3495 28.4139 25.8211C28.7788 26.186 28.7788 26.7776 28.4139 27.1425L27.1426 28.4138C26.7777 28.7787 26.1861 28.7787 25.8212 28.4138C24.3496 26.9422 21.8333 27.9844 21.8333 30.0656C21.8333 30.5817 21.415 31 20.8989 31H18.9809C18.5312 31 18.1667 30.6355 18.1667 30.1858C18.1667 28.3134 15.8519 27.4342 14.6088 28.8344C14.3103 29.1707 13.7957 29.2013 13.4594 28.9027L12.0575 27.6582C11.6536 27.2997 11.6169 26.6817 11.9754 26.2778L12.3102 25.9006C13.71 24.3238 12.5906 21.8333 10.4822 21.8333H9.97778C9.43777 21.8333 9 21.3956 9 20.8556V19.1011C9 18.585 9.41835 18.1667 9.93441 18.1667C12.0155 18.1667 13.0578 15.6505 11.5862 14.1789C11.2213 13.814 11.2213 13.2224 11.5862 12.8575L12.8576 11.5862C13.2225 11.2213 13.8141 11.2213 14.179 11.5862C15.6505 13.0577 18.1667 12.0155 18.1667 9.93439C18.1667 9.41834 18.585 9 19.1011 9H21.0191ZM20 23.3C21.8225 23.3 23.3 21.8225 23.3 20C23.3 18.1775 21.8225 16.7 20 16.7C18.1775 16.7 16.7 18.1775 16.7 20C16.7 21.8225 18.1775 23.3 20 23.3Z"
          fill={`${color}40`}
        />
      </svg>
    </div>
  );
};

export const AllClientIcon: React.FC<IconProps> = ({
  active = false,
  color = "#004B8B",
}) => {
  return active ? (
    <div>
      <svg
        width="40"
        height="40"
        viewBox="0 0 40 40"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <ellipse
          cx="22.3347"
          cy="12.9278"
          rx="2.93141"
          ry="2.93141"
          stroke={color}
          stroke-width="2"
          stroke-linecap="round"
        />
        <path
          d="M24.1167 10.9137C23.8336 12.3295 21.2852 14.0284 19.5863 13.394C18.7769 11.992 19.3068 11.1391 20.7089 10.3296C22.111 9.5201 22.9841 9.78115 24.1167 10.9137Z"
          fill={color}
        />
        <path
          d="M25.7765 21.109C26.6217 21.109 27.3273 20.3855 26.9187 19.6456C26.6625 19.1817 26.2869 18.7601 25.8135 18.405C25.34 18.0499 24.7779 17.7682 24.1593 17.5761C23.5407 17.3839 22.8777 17.285 22.2081 17.285C21.5385 17.285 20.8755 17.3839 20.2569 17.5761C19.6383 17.7682 19.0762 18.0499 18.6028 18.405C18.1293 18.7601 17.7537 19.1817 17.4975 19.6456C17.0889 20.3855 17.7945 21.109 18.6397 21.109H25.7765Z"
          fill={color}
        />
        <rect
          x="5"
          y="19.8343"
          width="3.14461"
          height="9.56015"
          rx="1"
          fill={color}
        />
        <path
          d="M8.82422 21.0779C8.82422 21.0779 10.0989 19.8343 12.0109 19.8343C13.3314 19.8343 14.4998 20.4867 15.5163 21.0543C15.9717 21.3085 16.3966 21.5458 16.791 21.6997C17.8032 22.0947 20.9585 23.0385 23.3853 23.5662C24.0816 23.7176 24.6556 24.1972 24.9198 24.8239C25.0328 25.092 24.9656 25.4062 24.718 25.559C24.4662 25.7142 24.0714 25.8634 23.4853 25.948C22.3117 26.1175 20.4195 26.0213 17.5088 25.2619C17.3385 25.2175 17.1644 25.3196 17.12 25.4898C17.0755 25.6601 17.1776 25.8342 17.3479 25.8786C20.3007 26.6489 22.2856 26.7652 23.5764 26.5788C24.2225 26.4855 24.7068 26.3146 25.0525 26.1014C25.0825 26.0829 25.1298 26.0518 25.1913 26.0101C26.8589 24.8789 28.4843 23.6777 30.208 22.6339L33.5576 20.6056C34.0248 20.3227 34.6106 20.3236 35.0768 20.6079C35.9456 21.1376 36.0215 22.3705 35.2243 23.0028L26.8027 29.6821C26.0266 30.2976 25.1526 30.7783 24.2173 31.1042L23.06 31.5074C21.0708 32.2004 18.8994 32.1604 16.9371 31.3946L8.82422 28.2286V21.0779Z"
          fill={color}
        />
      </svg>
    </div>
  ) : (
    <div>
      <svg
        width="40"
        height="40"
        viewBox="0 0 40 40"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <ellipse
          cx="22.3347"
          cy="12.9278"
          rx="2.93141"
          ry="2.93141"
          stroke={`${color}40`}
          stroke-width="2"
          stroke-linecap="round"
        />
        <path
          d="M24.1167 10.9137C23.8336 12.3295 21.2852 14.0284 19.5863 13.394C18.7769 11.992 19.3068 11.1391 20.7089 10.3296C22.111 9.5201 22.9841 9.78115 24.1167 10.9137Z"
          fill={`${color}40`}
        />
        <path
          d="M25.7765 21.109C26.6217 21.109 27.3273 20.3855 26.9187 19.6456C26.6625 19.1817 26.2869 18.7601 25.8135 18.405C25.34 18.0499 24.7779 17.7682 24.1593 17.5761C23.5407 17.3839 22.8777 17.285 22.2081 17.285C21.5385 17.285 20.8755 17.3839 20.2569 17.5761C19.6383 17.7682 19.0762 18.0499 18.6028 18.405C18.1293 18.7601 17.7537 19.1817 17.4975 19.6456C17.0889 20.3855 17.7945 21.109 18.6397 21.109H25.7765Z"
          fill={`${color}40`}
        />
        <rect
          x="5"
          y="19.8343"
          width="3.14461"
          height="9.56015"
          rx="1"
          fill={`${color}40`}
        />
        <path
          d="M8.82422 21.0779C8.82422 21.0779 10.0989 19.8343 12.0109 19.8343C13.3314 19.8343 14.4998 20.4867 15.5163 21.0543C15.9717 21.3085 16.3966 21.5458 16.791 21.6997C17.8032 22.0947 20.9585 23.0385 23.3853 23.5662C24.0816 23.7176 24.6556 24.1972 24.9198 24.8239C25.0328 25.092 24.9656 25.4062 24.718 25.559C24.4662 25.7142 24.0714 25.8634 23.4853 25.948C22.3117 26.1175 20.4195 26.0213 17.5088 25.2619C17.3385 25.2175 17.1644 25.3196 17.12 25.4898C17.0755 25.6601 17.1776 25.8342 17.3479 25.8786C20.3007 26.6489 22.2856 26.7652 23.5764 26.5788C24.2225 26.4855 24.7068 26.3146 25.0525 26.1014C25.0825 26.0829 25.1298 26.0518 25.1913 26.0101C26.8589 24.8789 28.4843 23.6777 30.208 22.6339L33.5576 20.6056C34.0248 20.3227 34.6106 20.3236 35.0768 20.6079C35.9456 21.1376 36.0215 22.3705 35.2243 23.0028L26.8027 29.6821C26.0266 30.2976 25.1526 30.7783 24.2173 31.1042L23.06 31.5074C21.0708 32.2004 18.8994 32.1604 16.9371 31.3946L8.82422 28.2286V21.0779Z"
          fill={`${color}40`}
        />
      </svg>
    </div>
  );
};

export const UserIcon: React.FC<IconProps> = ({
  active = false,
  color = "#004B8B",
}) => {
  return active ? (
    <div>
      <svg
        width="40"
        height="40"
        viewBox="0 0 40 40"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <ellipse
          cx="20.199"
          cy="15.163"
          rx="4.59941"
          ry="4.59942"
          stroke={color}
          stroke-width="2"
          stroke-linecap="round"
        />
        <path
          d="M22.995 12.0022C22.5507 14.2235 18.5524 16.8891 15.8868 15.8939C14.6167 13.694 15.4482 12.3558 17.6481 11.0857C19.848 9.8156 21.2179 10.2252 22.995 12.0022Z"
          fill={color}
        />
        <path
          d="M26.3977 31C28.0545 31 29.4436 29.6224 28.9128 28.0529C28.8475 27.8597 28.7757 27.6686 28.6974 27.4797C28.2352 26.3637 27.5576 25.3496 26.7034 24.4954C25.8492 23.6412 24.8351 22.9637 23.7191 22.5014C22.603 22.0391 21.4068 21.8011 20.1988 21.8011C18.9908 21.8011 17.7946 22.0391 16.6786 22.5014C15.5625 22.9637 14.5485 23.6412 13.6943 24.4954C12.8401 25.3496 12.1625 26.3637 11.7002 27.4797C11.622 27.6686 11.5502 27.8597 11.4849 28.0529C10.9541 29.6224 12.3431 31 14 31H26.3977Z"
          fill={color}
        />
      </svg>
    </div>
  ) : (
    <div>
      <svg
        width="40"
        height="40"
        viewBox="0 0 40 40"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <ellipse
          cx="20.199"
          cy="15.163"
          rx="4.59941"
          ry="4.59942"
          stroke={`${color}40`}
          stroke-width="2"
          stroke-linecap="round"
        />
        <path
          d="M22.995 12.0022C22.5507 14.2235 18.5524 16.8891 15.8868 15.8939C14.6167 13.694 15.4482 12.3558 17.6481 11.0857C19.848 9.8156 21.2179 10.2252 22.995 12.0022Z"
          fill={`${color}40`}
        />
        <path
          d="M26.3977 31C28.0545 31 29.4436 29.6224 28.9128 28.0529C28.8475 27.8597 28.7757 27.6686 28.6974 27.4797C28.2352 26.3637 27.5576 25.3496 26.7034 24.4954C25.8492 23.6412 24.8351 22.9637 23.7191 22.5014C22.603 22.0391 21.4068 21.8011 20.1988 21.8011C18.9908 21.8011 17.7946 22.0391 16.6786 22.5014C15.5625 22.9637 14.5485 23.6412 13.6943 24.4954C12.8401 25.3496 12.1625 26.3637 11.7002 27.4797C11.622 27.6686 11.5502 27.8597 11.4849 28.0529C10.9541 29.6224 12.3431 31 14 31H26.3977Z"
          fill={`${color}40`}
        />
      </svg>
    </div>
  );
};

export const MenuIcon: React.FC<IconProps> = ({
  active = false,
  color = "#004B8B",
}) => {
  return active ? (
    <svg
      width="30"
      height="30"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect
        x="4"
        y="4"
        width="16"
        height="16"
        rx="2"
        fill="white"
        stroke="white"
        stroke-width="1.6"
        stroke-linecap="round"
      />
      <path
        d="M12 4H18C19.1046 4 20 4.89543 20 6V18C20 19.1046 19.1046 20 18 20H12V4Z"
        fill={color}
        stroke="white"
        stroke-width="1.6"
        stroke-linecap="round"
      />
      <path
        d="M7 7H9"
        stroke={color}
        stroke-width="1.6"
        stroke-linecap="round"
      />
      <path
        d="M7 10H9"
        stroke={color}
        stroke-width="1.6"
        stroke-linecap="round"
      />
      <path
        d="M7 13H9"
        stroke={color}
        stroke-width="1.6"
        stroke-linecap="round"
      />
    </svg>
  ) : (
    <svg
      width="30"
      height="30"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect
        x="4"
        y="4"
        width="16"
        height="16"
        rx="2"
        stroke="white"
        stroke-width="1.6"
        stroke-linecap="round"
      />
      <path
        d="M12 4H18C19.1046 4 20 4.89543 20 6V18C20 19.1046 19.1046 20 18 20H12V4Z"
        stroke="white"
        stroke-width="1.6"
        stroke-linecap="round"
      />
      <path
        d="M7 7H9"
        stroke="white"
        stroke-width="1.6"
        stroke-linecap="round"
      />
      <path
        d="M7 10H9"
        stroke="white"
        stroke-width="1.6"
        stroke-linecap="round"
      />
      <path
        d="M7 13H9"
        stroke="white"
        stroke-width="1.6"
        stroke-linecap="round"
      />
    </svg>
  );
};

export const DraftIcon: React.FC<IconProps> = ({
  active = false,
  color = "#004B8B",
}) => {
  return active ? (
    <div>
      <svg
        width="40"
        height="40"
        viewBox="0 0 40 40"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M9 15.8717C9 15.2603 9.4956 14.7647 10.107 14.7647C10.7183 14.7647 11.2139 15.2603 11.2139 15.8717V23.4561C11.2139 26.3998 13.6002 28.7861 16.5439 28.7861H22.5629C22.8565 28.7861 23.138 28.9027 23.3456 29.1103C24.043 29.8077 23.5491 31 22.5629 31H16C12.134 31 9 27.866 9 24V15.8717Z"
          fill={color}
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M17.2393 8C15.0301 8 13.2393 9.79086 13.2393 12V22.7608C13.2393 24.9699 15.0301 26.7608 17.2393 26.7608H26.5569C28.766 26.7608 30.5569 24.9699 30.5569 22.7608V12C30.5569 9.79086 28.766 8 26.5569 8H17.2393ZM25.6697 12.4102C25.0992 11.8536 24.1855 11.8649 23.6289 12.4353L16.3668 19.8787L16 22.4753L18.5868 22.0446L25.8489 14.6013C26.4055 14.0308 26.3943 13.1171 25.8238 12.5605L25.6697 12.4102ZM23.8823 22.2516C23.8823 22.9988 23.2766 23.6045 22.5294 23.6045C21.7821 23.6045 21.1764 22.9988 21.1764 22.2516C21.1764 21.5044 21.7821 20.8987 22.5294 20.8987C23.2766 20.8987 23.8823 21.5044 23.8823 22.2516ZM26.8588 23.6045C27.606 23.6045 28.2117 22.9988 28.2117 22.2516C28.2117 21.5044 27.606 20.8987 26.8588 20.8987C26.1116 20.8987 25.5058 21.5044 25.5058 22.2516C25.5058 22.9988 26.1116 23.6045 26.8588 23.6045Z"
          fill={color}
        />
      </svg>
    </div>
  ) : (
    <div>
      <svg
        width="40"
        height="40"
        viewBox="0 0 40 40"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M9 15.8717C9 15.2603 9.4956 14.7647 10.107 14.7647C10.7183 14.7647 11.2139 15.2603 11.2139 15.8717V23.4561C11.2139 26.3998 13.6002 28.7861 16.5439 28.7861H22.5629C22.8565 28.7861 23.138 28.9027 23.3456 29.1103C24.043 29.8077 23.5491 31 22.5629 31H16C12.134 31 9 27.866 9 24V15.8717Z"
          fill={`${color}40`}
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M17.2393 8C15.0301 8 13.2393 9.79086 13.2393 12V22.7608C13.2393 24.9699 15.0301 26.7608 17.2393 26.7608H26.5569C28.766 26.7608 30.5569 24.9699 30.5569 22.7608V12C30.5569 9.79086 28.766 8 26.5569 8H17.2393ZM25.6697 12.4102C25.0992 11.8536 24.1855 11.8649 23.6289 12.4353L16.3668 19.8787L16 22.4753L18.5868 22.0446L25.8489 14.6013C26.4055 14.0308 26.3943 13.1171 25.8238 12.5605L25.6697 12.4102ZM23.8823 22.2516C23.8823 22.9988 23.2766 23.6045 22.5294 23.6045C21.7821 23.6045 21.1764 22.9988 21.1764 22.2516C21.1764 21.5044 21.7821 20.8987 22.5294 20.8987C23.2766 20.8987 23.8823 21.5044 23.8823 22.2516ZM26.8588 23.6045C27.606 23.6045 28.2117 22.9988 28.2117 22.2516C28.2117 21.5044 27.606 20.8987 26.8588 20.8987C26.1116 20.8987 25.5058 21.5044 25.5058 22.2516C25.5058 22.9988 26.1116 23.6045 26.8588 23.6045Z"
          fill={`${color}40`}
        />
      </svg>
    </div>
  );
};

export const ReportIcon: React.FC<IconProps> = ({
  active = false,
  color = "#004B8B",
}) => {
  return active ? (
    <div>
      <svg
        width="40"
        height="40"
        viewBox="0 0 40 40"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M14 9C11.7909 9 10 10.7909 10 13V28C10 30.2091 11.7909 32 14 32H26C28.2091 32 30 30.2091 30 28V13C30 10.7909 28.2091 9 26 9H14ZM21.4712 18.5834C21.97 17.8742 22.2362 17.0404 22.2362 16.1875H17.6968V11.875C16.7989 11.875 15.9213 12.1279 15.1748 12.6018C14.4282 13.0757 13.8464 13.7492 13.5028 14.5372C13.1592 15.3252 13.0693 16.1923 13.2445 17.0288C13.4197 17.8654 13.852 18.6338 14.4869 19.2369C15.1217 19.84 15.9306 20.2507 16.8111 20.4171C17.6917 20.5835 18.6045 20.4981 19.4339 20.1717C20.2634 19.8453 20.9724 19.2926 21.4712 18.5834ZM13.1573 23.8931C13.1573 24.3865 13.5783 24.7865 14.0977 24.7865H24.3831C24.9025 24.7865 25.3235 24.3865 25.3235 23.8931C25.3235 23.3997 24.9025 22.9998 24.3831 22.9998H14.0977C13.5783 22.9998 13.1573 23.3997 13.1573 23.8931ZM14.3166 29.1262C13.7973 29.1262 13.3762 28.7262 13.3762 28.2329C13.3762 27.7395 13.7973 27.3395 14.3166 27.3395H20.6324C21.1518 27.3395 21.5728 27.7395 21.5728 28.2329C21.5728 28.7262 21.1518 29.1262 20.6324 29.1262H14.3166Z"
          fill={color}
        />
      </svg>
    </div>
  ) : (
    <div>
      <svg
        width="40"
        height="40"
        viewBox="0 0 40 40"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M14 9C11.7909 9 10 10.7909 10 13V28C10 30.2091 11.7909 32 14 32H26C28.2091 32 30 30.2091 30 28V13C30 10.7909 28.2091 9 26 9H14ZM21.4712 18.5834C21.97 17.8742 22.2362 17.0404 22.2362 16.1875H17.6968V11.875C16.7989 11.875 15.9213 12.1279 15.1748 12.6018C14.4282 13.0757 13.8464 13.7492 13.5028 14.5372C13.1592 15.3252 13.0693 16.1923 13.2445 17.0288C13.4197 17.8654 13.852 18.6338 14.4869 19.2369C15.1217 19.84 15.9306 20.2507 16.8111 20.4171C17.6917 20.5835 18.6045 20.4981 19.4339 20.1717C20.2634 19.8453 20.9724 19.2926 21.4712 18.5834ZM13.1573 23.8931C13.1573 24.3865 13.5783 24.7865 14.0977 24.7865H24.3831C24.9025 24.7865 25.3235 24.3865 25.3235 23.8931C25.3235 23.3997 24.9025 22.9998 24.3831 22.9998H14.0977C13.5783 22.9998 13.1573 23.3997 13.1573 23.8931ZM14.3166 29.1262C13.7973 29.1262 13.3762 28.7262 13.3762 28.2329C13.3762 27.7395 13.7973 27.3395 14.3166 27.3395H20.6324C21.1518 27.3395 21.5728 27.7395 21.5728 28.2329C21.5728 28.7262 21.1518 29.1262 20.6324 29.1262H14.3166Z"
          fill={`${color}40`}
        />
      </svg>
    </div>
  );
};

export const AssetIcon: React.FC<IconProps> = ({
  active = false,
  color = "#004B8B",
}) => {
  return active ? (
    <div>
      <svg
        width="40"
        height="40"
        viewBox="0 0 40 40"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M14.3843 10.3716C14.5153 10.1418 14.7595 10 15.024 10H21.732C22.2973 10 22.6519 10.6105 22.3717 11.1015C22.2407 11.3313 21.9965 11.4731 21.732 11.4731H19.4201C19.8235 11.9003 20.126 12.4012 20.3025 12.9462H21.732C22.2973 12.9462 22.6519 13.5567 22.3717 14.0477C22.2407 14.2775 21.9965 14.4193 21.732 14.4193H20.479C20.3745 15.3375 19.9193 16.1979 19.1872 16.861C18.455 17.5241 17.4888 17.951 16.4451 18.0726V18.1021H15.8568L20.3025 22.7775L18.3371 22.9455L14.044 18.4067C13.859 18.2111 13.7559 17.952 13.7559 17.6827C13.7559 17.1007 14.2276 16.629 14.8096 16.629H15.8568C17.3359 16.629 18.5629 15.6714 18.7646 14.4193H15.024C14.4587 14.4193 14.1041 13.8088 14.3843 13.3178C14.5153 13.088 14.7595 12.9462 15.024 12.9462H18.5125C18.0418 12.0771 17.0334 11.4731 15.8568 11.4731H15.024C14.4587 11.4731 14.1041 10.8626 14.3843 10.3716Z"
          fill={color}
        />
        <path
          d="M10 22.9L10 28.8998"
          stroke="#004B8B"
          stroke-width="2"
          stroke-linecap="round"
        />
        <path
          d="M11.5 28.0005V25V23.0405C11.5 22.6048 11.7953 22.2245 12.2174 22.1166L13.3595 21.8247C14.4371 21.5492 15.5752 21.6346 16.5996 22.0678C17.913 22.6232 19.3992 22.6016 20.6959 22.0084L21.4974 21.6417C21.8115 21.498 22.1825 21.5757 22.4125 21.8333L22.522 21.9559C22.7171 22.1745 22.8213 22.4765 22.6808 22.7335C22.2 23.6133 20.644 24.5424 18.5 25.4C20.3286 26.3143 22.8466 25.1293 28.6232 23.5601C29.5085 23.3197 30.3855 23.9595 30.4395 24.8753C30.4758 25.4901 30.1226 26.0618 29.5565 26.3044L23.0939 29.0741C21.0653 29.9435 18.8475 30.278 16.6526 30.0456L12.9912 29.6579C12.1434 29.5681 11.5 28.8531 11.5 28.0005Z"
          fill={color}
        />
      </svg>
    </div>
  ) : (
    <div>
      <svg
        width="40"
        height="40"
        viewBox="0 0 40 40"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M14.3843 10.3716C14.5153 10.1418 14.7595 10 15.024 10H21.732C22.2973 10 22.6519 10.6105 22.3717 11.1015C22.2407 11.3313 21.9965 11.4731 21.732 11.4731H19.4201C19.8235 11.9003 20.126 12.4012 20.3025 12.9462H21.732C22.2973 12.9462 22.6519 13.5567 22.3717 14.0477C22.2407 14.2775 21.9965 14.4193 21.732 14.4193H20.479C20.3745 15.3375 19.9193 16.1979 19.1872 16.861C18.455 17.5241 17.4888 17.951 16.4451 18.0726V18.1021H15.8568L20.3025 22.7775L18.3371 22.9455L14.044 18.4067C13.859 18.2111 13.7559 17.952 13.7559 17.6827C13.7559 17.1007 14.2276 16.629 14.8096 16.629H15.8568C17.3359 16.629 18.5629 15.6714 18.7646 14.4193H15.024C14.4587 14.4193 14.1041 13.8088 14.3843 13.3178C14.5153 13.088 14.7595 12.9462 15.024 12.9462H18.5125C18.0418 12.0771 17.0334 11.4731 15.8568 11.4731H15.024C14.4587 11.4731 14.1041 10.8626 14.3843 10.3716Z"
          fill={`${color}40`}
        />
        <path
          d="M10 22.9L10 28.8998"
          stroke="#AAC9E3"
          stroke-width="2"
          stroke-linecap="round"
        />
        <path
          d="M11.5 28.0005V25V23.0405C11.5 22.6048 11.7953 22.2245 12.2174 22.1166L13.3595 21.8247C14.4371 21.5492 15.5752 21.6346 16.5996 22.0678C17.913 22.6232 19.3992 22.6016 20.6959 22.0084L21.4974 21.6417C21.8115 21.498 22.1825 21.5757 22.4125 21.8333L22.522 21.9559C22.7171 22.1745 22.8213 22.4765 22.6808 22.7335C22.2 23.6133 20.644 24.5424 18.5 25.4C20.3286 26.3143 22.8466 25.1293 28.6232 23.5601C29.5085 23.3197 30.3855 23.9595 30.4395 24.8753C30.4758 25.4901 30.1226 26.0618 29.5565 26.3044L23.0939 29.0741C21.0653 29.9435 18.8475 30.278 16.6526 30.0456L12.9912 29.6579C12.1434 29.5681 11.5 28.8531 11.5 28.0005Z"
          fill={`${color}40`}
        />
      </svg>
    </div>
  );
};

export const JournalIcon: React.FC<IconProps> = ({
  active = false,
  color = "#004B8B",
}) => {
  return active ? (
    <div>
      <svg
        width="40"
        height="40"
        viewBox="0 0 40 40"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M10 13.5143C10 13.0409 10.3838 12.6571 10.8572 12.6571H11.4806V14.3716H10.8572C10.3838 14.3716 10 13.9878 10 13.5143Z"
          fill={color}
        />
        <path
          d="M10 18.0609C10 17.5874 10.3838 17.2036 10.8572 17.2036H11.4806V18.9181H10.8572C10.3838 18.9181 10 18.5343 10 18.0609Z"
          fill={color}
        />
        <path
          d="M10 22.7062C10 22.2328 10.3838 21.849 10.8572 21.849H11.4806V23.5635H10.8572C10.3838 23.5635 10 23.1797 10 22.7062Z"
          fill={color}
        />
        <path
          d="M27.6628 22.3666C27.9844 22.0117 28.5378 21.979 28.8989 22.2938L29.3463 22.6838C29.7074 22.9985 29.7394 23.5414 29.4178 23.8964L24.0452 29.8265L22.1043 30.2353L22.2902 28.2967L27.6628 22.3666Z"
          fill={color}
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M14.9488 9.00012C13.0328 9.00012 11.4795 10.5534 11.4795 12.4694V24.3902C11.4795 26.3062 13.0328 27.8595 14.9488 27.8595H20.1299C21.1256 27.8595 22.0733 27.4317 22.7318 26.685L26.3434 22.5901C26.9024 21.9563 27.2108 21.1403 27.2108 20.2953V12.4694C27.2108 10.5534 25.6576 9.00012 23.7415 9.00012H14.9488ZM13.2285 14.3715C13.7111 14.3715 14.1024 13.9877 14.1024 13.5143C14.1024 13.0408 13.7111 12.657 13.2285 12.657C12.7458 12.657 12.3545 13.0408 12.3545 13.5143C12.3545 13.9877 12.7458 14.3715 13.2285 14.3715ZM14.1024 22.7062C14.1024 23.1796 13.7111 23.5634 13.2285 23.5634C12.7458 23.5634 12.3545 23.1796 12.3545 22.7062C12.3545 22.2328 12.7458 21.849 13.2285 21.849C13.7111 21.849 14.1024 22.2328 14.1024 22.7062ZM13.2285 18.9181C13.7111 18.9181 14.1024 18.5343 14.1024 18.0609C14.1024 17.5875 13.7111 17.2037 13.2285 17.2037C12.7458 17.2037 12.3545 17.5875 12.3545 18.0609C12.3545 18.5343 12.7458 18.9181 13.2285 18.9181Z"
          fill={color}
        />
      </svg>
    </div>
  ) : (
    <div>
      <svg
        width="40"
        height="40"
        viewBox="0 0 40 40"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M10 13.5143C10 13.0409 10.3838 12.6571 10.8572 12.6571H11.4806V14.3716H10.8572C10.3838 14.3716 10 13.9878 10 13.5143Z"
          fill={`${color}40`}
        />
        <path
          d="M10 18.0609C10 17.5874 10.3838 17.2036 10.8572 17.2036H11.4806V18.9181H10.8572C10.3838 18.9181 10 18.5343 10 18.0609Z"
          fill={`${color}40`}
        />
        <path
          d="M10 22.7062C10 22.2328 10.3838 21.849 10.8572 21.849H11.4806V23.5635H10.8572C10.3838 23.5635 10 23.1797 10 22.7062Z"
          fill={`${color}40`}
        />
        <path
          d="M27.6628 22.3666C27.9844 22.0117 28.5378 21.979 28.8989 22.2938L29.3463 22.6838C29.7074 22.9985 29.7394 23.5414 29.4178 23.8964L24.0452 29.8265L22.1043 30.2353L22.2902 28.2967L27.6628 22.3666Z"
          fill={`${color}40`}
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M14.9488 9.00012C13.0328 9.00012 11.4795 10.5534 11.4795 12.4694V24.3902C11.4795 26.3062 13.0328 27.8595 14.9488 27.8595H20.1299C21.1256 27.8595 22.0733 27.4317 22.7318 26.685L26.3434 22.5901C26.9024 21.9563 27.2108 21.1403 27.2108 20.2953V12.4694C27.2108 10.5534 25.6576 9.00012 23.7415 9.00012H14.9488ZM13.2285 14.3715C13.7111 14.3715 14.1024 13.9877 14.1024 13.5143C14.1024 13.0408 13.7111 12.657 13.2285 12.657C12.7458 12.657 12.3545 13.0408 12.3545 13.5143C12.3545 13.9877 12.7458 14.3715 13.2285 14.3715ZM14.1024 22.7062C14.1024 23.1796 13.7111 23.5634 13.2285 23.5634C12.7458 23.5634 12.3545 23.1796 12.3545 22.7062C12.3545 22.2328 12.7458 21.849 13.2285 21.849C13.7111 21.849 14.1024 22.2328 14.1024 22.7062ZM13.2285 18.9181C13.7111 18.9181 14.1024 18.5343 14.1024 18.0609C14.1024 17.5875 13.7111 17.2037 13.2285 17.2037C12.7458 17.2037 12.3545 17.5875 12.3545 18.0609C12.3545 18.5343 12.7458 18.9181 13.2285 18.9181Z"
          fill={`${color}40`}
        />
      </svg>
    </div>
  );
};

export const CapsiBooksLogoforHeaderWithTitle = () => {
  return (
    <svg
      width="201"
      height="38"
      viewBox="0 0 201 38"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M29.1334 23.2987C29.6266 23.85 29.5796 24.6968 29.0283 25.1901L19.6603 33.5723C19.1585 34.0213 18.4014 34.028 17.8918 33.588L14.5717 30.7217L8.73938 35.3006C8.15752 35.7574 7.31551 35.6561 6.8587 35.0742C6.40189 34.4923 6.50327 33.6503 7.08513 33.1935L13.785 27.9335C14.289 27.5379 15.0025 27.5545 15.4874 27.9732L18.7513 30.7909L27.242 23.1937C27.7933 22.7004 28.6401 22.7474 29.1334 23.2987Z"
        fill="white"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M20.7196 20.2501C20.7196 19.5103 21.3193 18.9106 22.059 18.9106H32.784C33.5237 18.9106 34.1234 19.5103 34.1234 20.2501V30.3468C34.1234 31.0866 33.5237 31.6863 32.784 31.6863C32.0442 31.6863 31.4445 31.0866 31.4445 30.3468V21.5895H22.059C21.3193 21.5895 20.7196 20.9898 20.7196 20.2501Z"
        fill="white"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M7.10181 4.17365C7.90358 2.90085 9.41203 2.13245 11.7029 2.13245H28.8497C31.1416 2.13245 32.6506 2.90056 33.4522 4.17403C34.1318 5.25367 34.1295 6.47325 34.1284 7.03799C34.1284 7.05927 34.1283 7.07962 34.1283 7.09899V13.0094C34.1283 13.7519 33.4812 14.3539 32.6829 14.3539C31.8846 14.3539 31.2375 13.7519 31.2375 13.0094V7.09899C31.2375 6.47367 31.2099 5.93366 30.9575 5.53269C30.8015 5.28487 30.3939 4.82143 28.8497 4.82143H11.7029C10.1607 4.82143 9.75251 5.28458 9.59598 5.53307C9.34327 5.93425 9.31515 6.47481 9.31515 7.09899V21.6666C9.31515 22.4091 8.66802 23.011 7.86975 23.011C7.07147 23.011 6.42435 22.4091 6.42435 21.6666V7.09899C6.42435 7.08013 6.42431 7.06035 6.42428 7.03969C6.42328 6.47478 6.42112 5.25424 7.10181 4.17365Z"
        fill="white"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M10.8416 8.75795C10.8416 7.98183 11.4899 7.35266 12.2897 7.35266H27.8629C28.6627 7.35266 29.3111 7.98183 29.3111 8.75795C29.3111 9.53407 28.6627 10.1632 27.8629 10.1632H12.2897C11.4899 10.1632 10.8416 9.53407 10.8416 8.75795Z"
        fill="white"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M10.8416 13.575C10.8416 12.7988 11.4899 12.1697 12.2897 12.1697H27.8629C28.6627 12.1697 29.3111 12.7988 29.3111 13.575C29.3111 14.3511 28.6627 14.9803 27.8629 14.9803H12.2897C11.4899 14.9803 10.8416 14.3511 10.8416 13.575Z"
        fill="white"
      />
      <path
        d="M56.3877 29.336C54.5024 29.336 52.8224 28.9067 51.3477 28.048C49.8917 27.1707 48.7437 25.976 47.9037 24.464C47.0824 22.9333 46.6717 21.1787 46.6717 19.2C46.6717 17.2213 47.0824 15.476 47.9037 13.964C48.7437 12.4333 49.8917 11.2387 51.3477 10.38C52.8037 9.50267 54.4744 9.064 56.3597 9.064C57.629 9.064 58.8237 9.29733 59.9437 9.764C61.0637 10.212 62.053 10.8373 62.9117 11.64C63.789 12.4427 64.461 13.376 64.9277 14.44L61.9597 15.644C61.6237 14.9347 61.1664 14.3093 60.5877 13.768C60.0277 13.208 59.3837 12.7787 58.6557 12.48C57.9277 12.1813 57.1624 12.032 56.3597 12.032C55.1277 12.032 54.0264 12.34 53.0557 12.956C52.1037 13.572 51.3477 14.4213 50.7877 15.504C50.2464 16.568 49.9757 17.8 49.9757 19.2C49.9757 20.6 50.2464 21.8413 50.7877 22.924C51.3477 24.0067 52.113 24.856 53.0837 25.472C54.073 26.088 55.193 26.396 56.4437 26.396C57.265 26.396 58.0304 26.2373 58.7397 25.92C59.4677 25.584 60.1117 25.1267 60.6717 24.548C61.2504 23.9693 61.7077 23.2973 62.0437 22.532L65.0117 23.736C64.545 24.8373 63.8824 25.8173 63.0237 26.676C62.165 27.516 61.1664 28.1693 60.0277 28.636C58.889 29.1027 57.6757 29.336 56.3877 29.336ZM76.0901 29L75.9501 26.368V21.804C75.9501 20.852 75.8474 20.0587 75.6421 19.424C75.4554 18.7707 75.1381 18.276 74.6901 17.94C74.2608 17.5853 73.6821 17.408 72.9541 17.408C72.2821 17.408 71.6941 17.548 71.1901 17.828C70.6861 18.108 70.2568 18.5467 69.9021 19.144L67.1581 18.136C67.4568 17.52 67.8488 16.9507 68.3341 16.428C68.8381 15.8867 69.4634 15.4573 70.2101 15.14C70.9754 14.8227 71.8901 14.664 72.9541 14.664C74.3168 14.664 75.4554 14.9347 76.3701 15.476C77.2848 15.9987 77.9568 16.7547 78.3861 17.744C78.8341 18.7333 79.0581 19.928 79.0581 21.328L78.9741 29H76.0901ZM72.0581 29.336C70.3781 29.336 69.0714 28.9627 68.1381 28.216C67.2234 27.4693 66.7661 26.4147 66.7661 25.052C66.7661 23.596 67.2514 22.4853 68.2221 21.72C69.2114 20.9547 70.5834 20.572 72.3381 20.572H76.0901V22.98H73.3461C72.0954 22.98 71.2181 23.1573 70.7141 23.512C70.2101 23.848 69.9581 24.3333 69.9581 24.968C69.9581 25.5093 70.1728 25.9387 70.6021 26.256C71.0501 26.5547 71.6661 26.704 72.4501 26.704C73.1594 26.704 73.7754 26.5453 74.2981 26.228C74.8208 25.9107 75.2221 25.4907 75.5021 24.968C75.8008 24.4453 75.9501 23.8573 75.9501 23.204H76.8741C76.8741 25.108 76.4914 26.6107 75.7261 27.712C74.9608 28.7947 73.7381 29.336 72.0581 29.336ZM82.3737 34.6V15H85.3137L85.5097 17.576V34.6H82.3737ZM89.9337 29.336C88.7577 29.336 87.7403 29.0373 86.8817 28.44C86.0417 27.824 85.3977 26.9653 84.9497 25.864C84.5017 24.7627 84.2777 23.4747 84.2777 22C84.2777 20.5067 84.5017 19.2187 84.9497 18.136C85.3977 17.0347 86.0417 16.1853 86.8817 15.588C87.7403 14.972 88.7577 14.664 89.9337 14.664C91.203 14.664 92.3043 14.972 93.2377 15.588C94.1897 16.1853 94.927 17.0347 95.4497 18.136C95.991 19.2187 96.2617 20.5067 96.2617 22C96.2617 23.4747 95.991 24.7627 95.4497 25.864C94.927 26.9653 94.1897 27.824 93.2377 28.44C92.3043 29.0373 91.203 29.336 89.9337 29.336ZM89.1497 26.48C89.8963 26.48 90.559 26.2933 91.1377 25.92C91.7163 25.528 92.1737 24.996 92.5097 24.324C92.8643 23.652 93.0417 22.8773 93.0417 22C93.0417 21.1227 92.8737 20.348 92.5377 19.676C92.2203 19.004 91.7723 18.4813 91.1937 18.108C90.615 17.7347 89.943 17.548 89.1777 17.548C88.4683 17.548 87.8337 17.7347 87.2737 18.108C86.7137 18.4813 86.275 19.004 85.9577 19.676C85.659 20.348 85.5097 21.1227 85.5097 22C85.5097 22.8773 85.659 23.652 85.9577 24.324C86.275 24.996 86.7043 25.528 87.2457 25.92C87.8057 26.2933 88.4403 26.48 89.1497 26.48ZM104.037 29.336C103.103 29.336 102.245 29.196 101.461 28.916C100.677 28.636 100.005 28.244 99.4447 27.74C98.8847 27.2173 98.4554 26.6107 98.1567 25.92L100.873 24.716C101.153 25.2387 101.563 25.6773 102.105 26.032C102.665 26.3867 103.281 26.564 103.953 26.564C104.681 26.564 105.259 26.4427 105.689 26.2C106.137 25.9387 106.361 25.584 106.361 25.136C106.361 24.7067 106.193 24.38 105.857 24.156C105.521 23.9133 105.045 23.7173 104.429 23.568L103.113 23.204C101.787 22.868 100.751 22.336 100.005 21.608C99.258 20.8613 98.8847 20.012 98.8847 19.06C98.8847 17.66 99.3327 16.5773 100.229 15.812C101.143 15.0467 102.45 14.664 104.149 14.664C105.007 14.664 105.791 14.7947 106.501 15.056C107.229 15.2987 107.854 15.6533 108.377 16.12C108.899 16.568 109.263 17.1 109.469 17.716L106.865 18.892C106.678 18.4253 106.323 18.0707 105.801 17.828C105.278 17.5667 104.699 17.436 104.065 17.436C103.43 17.436 102.935 17.576 102.581 17.856C102.226 18.1173 102.049 18.4907 102.049 18.976C102.049 19.256 102.207 19.5173 102.525 19.76C102.842 19.984 103.299 20.1707 103.897 20.32L105.549 20.712C106.463 20.936 107.21 21.2907 107.789 21.776C108.367 22.2427 108.797 22.7747 109.077 23.372C109.357 23.9507 109.497 24.5387 109.497 25.136C109.497 25.976 109.254 26.7133 108.769 27.348C108.302 27.9827 107.658 28.4773 106.837 28.832C106.015 29.168 105.082 29.336 104.037 29.336ZM112.18 29V15H115.288V29H112.18ZM113.748 12.34C113.244 12.34 112.805 12.1627 112.432 11.808C112.077 11.4347 111.9 10.996 111.9 10.492C111.9 9.988 112.077 9.55867 112.432 9.204C112.805 8.84933 113.244 8.672 113.748 8.672C114.252 8.672 114.681 8.84933 115.036 9.204C115.409 9.55867 115.596 9.988 115.596 10.492C115.596 10.996 115.409 11.4347 115.036 11.808C114.681 12.1627 114.252 12.34 113.748 12.34ZM126.966 29V9.4H132.986C134.311 9.4 135.44 9.60533 136.374 10.016C137.307 10.4267 138.026 11.024 138.53 11.808C139.034 12.592 139.286 13.5347 139.286 14.636C139.286 15.6627 139.062 16.5493 138.614 17.296C138.166 18.0427 137.531 18.6307 136.71 19.06C137.718 19.5267 138.492 20.1613 139.034 20.964C139.575 21.748 139.846 22.6813 139.846 23.764C139.846 24.8653 139.603 25.808 139.118 26.592C138.632 27.376 137.932 27.9733 137.018 28.384C136.122 28.7947 135.03 29 133.742 29H126.966ZM128.758 27.348H133.742C135.104 27.348 136.168 27.0307 136.934 26.396C137.699 25.7613 138.082 24.884 138.082 23.764C138.082 22.532 137.634 21.58 136.738 20.908C135.842 20.2173 134.591 19.872 132.986 19.872H128.758V27.348ZM128.758 18.22H133.742C134.936 18.22 135.86 17.9027 136.514 17.268C137.186 16.6333 137.522 15.756 137.522 14.636C137.522 13.4787 137.12 12.592 136.318 11.976C135.534 11.3413 134.423 11.024 132.986 11.024H128.758V18.22ZM149.403 29.336C148.059 29.336 146.865 29.028 145.819 28.412C144.793 27.7773 143.981 26.9093 143.383 25.808C142.805 24.7067 142.515 23.4373 142.515 22C142.515 20.5627 142.805 19.2933 143.383 18.192C143.962 17.0907 144.765 16.232 145.791 15.616C146.837 14.9813 148.022 14.664 149.347 14.664C150.691 14.664 151.877 14.9813 152.903 15.616C153.949 16.232 154.761 17.0907 155.339 18.192C155.918 19.2933 156.207 20.5627 156.207 22C156.207 23.4373 155.918 24.7067 155.339 25.808C154.761 26.9093 153.958 27.7773 152.931 28.412C151.905 29.028 150.729 29.336 149.403 29.336ZM149.403 27.796C150.411 27.796 151.298 27.5533 152.063 27.068C152.829 26.564 153.426 25.8827 153.855 25.024C154.303 24.1467 154.527 23.1387 154.527 22C154.527 20.8613 154.303 19.8627 153.855 19.004C153.426 18.1267 152.819 17.4453 152.035 16.96C151.251 16.456 150.355 16.204 149.347 16.204C148.339 16.204 147.443 16.456 146.659 16.96C145.894 17.4453 145.287 18.1267 144.839 19.004C144.41 19.8627 144.195 20.8613 144.195 22C144.195 23.1387 144.419 24.1467 144.867 25.024C145.315 25.8827 145.931 26.564 146.715 27.068C147.499 27.5533 148.395 27.796 149.403 27.796ZM165.618 29.336C164.274 29.336 163.08 29.028 162.034 28.412C161.008 27.7773 160.196 26.9093 159.598 25.808C159.02 24.7067 158.73 23.4373 158.73 22C158.73 20.5627 159.02 19.2933 159.598 18.192C160.177 17.0907 160.98 16.232 162.006 15.616C163.052 14.9813 164.237 14.664 165.562 14.664C166.906 14.664 168.092 14.9813 169.118 15.616C170.164 16.232 170.976 17.0907 171.554 18.192C172.133 19.2933 172.422 20.5627 172.422 22C172.422 23.4373 172.133 24.7067 171.554 25.808C170.976 26.9093 170.173 27.7773 169.146 28.412C168.12 29.028 166.944 29.336 165.618 29.336ZM165.618 27.796C166.626 27.796 167.513 27.5533 168.278 27.068C169.044 26.564 169.641 25.8827 170.07 25.024C170.518 24.1467 170.742 23.1387 170.742 22C170.742 20.8613 170.518 19.8627 170.07 19.004C169.641 18.1267 169.034 17.4453 168.25 16.96C167.466 16.456 166.57 16.204 165.562 16.204C164.554 16.204 163.658 16.456 162.874 16.96C162.109 17.4453 161.502 18.1267 161.054 19.004C160.625 19.8627 160.41 20.8613 160.41 22C160.41 23.1387 160.634 24.1467 161.082 25.024C161.53 25.8827 162.146 26.564 162.93 27.068C163.714 27.5533 164.61 27.796 165.618 27.796ZM177.465 24.128L176.317 22.98L183.905 15H186.089L177.465 24.128ZM175.785 29V9.4H177.465V29H175.785ZM184.549 29L178.977 20.488L180.069 19.284L186.705 29H184.549ZM193.561 29.336C192.497 29.336 191.582 29.1773 190.817 28.86C190.051 28.5427 189.426 28.132 188.941 27.628C188.474 27.124 188.147 26.6013 187.961 26.06L189.473 25.5C189.79 26.1907 190.294 26.7507 190.985 27.18C191.694 27.5907 192.45 27.796 193.253 27.796C194.242 27.796 195.082 27.5907 195.773 27.18C196.463 26.7693 196.809 26.1907 196.809 25.444C196.809 24.772 196.557 24.2213 196.053 23.792C195.549 23.3627 194.802 23.0173 193.813 22.756L192.441 22.392C191.19 22.056 190.219 21.5707 189.529 20.936C188.857 20.2827 188.521 19.5547 188.521 18.752C188.521 17.464 188.941 16.4653 189.781 15.756C190.639 15.028 191.927 14.664 193.645 14.664C194.447 14.664 195.166 14.7853 195.801 15.028C196.454 15.252 197.005 15.5787 197.453 16.008C197.919 16.4373 198.265 16.9507 198.489 17.548L196.977 18.192C196.678 17.464 196.239 16.9507 195.661 16.652C195.082 16.3533 194.326 16.204 193.393 16.204C192.403 16.204 191.619 16.4187 191.041 16.848C190.481 17.2587 190.201 17.8467 190.201 18.612C190.201 19.0227 190.425 19.4333 190.873 19.844C191.339 20.236 192.03 20.5533 192.945 20.796L194.149 21.104C195.063 21.328 195.838 21.6547 196.473 22.084C197.126 22.4947 197.621 22.9707 197.957 23.512C198.311 24.0533 198.489 24.6507 198.489 25.304C198.489 26.144 198.274 26.872 197.845 27.488C197.415 28.0853 196.827 28.5427 196.081 28.86C195.353 29.1773 194.513 29.336 193.561 29.336Z"
        fill="white"
      />
    </svg>
  );
};

export const CapsiBookLogoOnly = () => {
  return (
    <svg
      width="41"
      height="38"
      viewBox="0 0 41 38"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M29.1334 23.2987C29.6266 23.85 29.5796 24.6968 29.0283 25.1901L19.6603 33.5723C19.1585 34.0213 18.4014 34.028 17.8918 33.588L14.5717 30.7217L8.73938 35.3006C8.15752 35.7574 7.31551 35.6561 6.8587 35.0742C6.40189 34.4923 6.50327 33.6503 7.08513 33.1935L13.785 27.9335C14.289 27.5379 15.0025 27.5545 15.4874 27.9732L18.7513 30.7909L27.242 23.1937C27.7933 22.7004 28.6401 22.7474 29.1334 23.2987Z"
        fill="white"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M20.7196 20.2501C20.7196 19.5103 21.3193 18.9106 22.059 18.9106H32.784C33.5237 18.9106 34.1234 19.5103 34.1234 20.2501V30.3468C34.1234 31.0866 33.5237 31.6863 32.784 31.6863C32.0442 31.6863 31.4445 31.0866 31.4445 30.3468V21.5895H22.059C21.3193 21.5895 20.7196 20.9898 20.7196 20.2501Z"
        fill="white"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M7.10181 4.17365C7.90358 2.90085 9.41203 2.13245 11.7029 2.13245H28.8497C31.1416 2.13245 32.6506 2.90056 33.4522 4.17403C34.1318 5.25367 34.1295 6.47325 34.1284 7.03799C34.1284 7.05927 34.1283 7.07962 34.1283 7.09899V13.0094C34.1283 13.7519 33.4812 14.3539 32.6829 14.3539C31.8846 14.3539 31.2375 13.7519 31.2375 13.0094V7.09899C31.2375 6.47367 31.2099 5.93366 30.9575 5.53269C30.8015 5.28487 30.3939 4.82143 28.8497 4.82143H11.7029C10.1607 4.82143 9.75251 5.28458 9.59598 5.53307C9.34327 5.93425 9.31515 6.47481 9.31515 7.09899V21.6666C9.31515 22.4091 8.66802 23.011 7.86975 23.011C7.07147 23.011 6.42435 22.4091 6.42435 21.6666V7.09899C6.42435 7.08013 6.42431 7.06035 6.42428 7.03969C6.42328 6.47478 6.42112 5.25424 7.10181 4.17365Z"
        fill="white"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M10.8416 8.75795C10.8416 7.98183 11.4899 7.35266 12.2897 7.35266H27.8629C28.6627 7.35266 29.3111 7.98183 29.3111 8.75795C29.3111 9.53407 28.6627 10.1632 27.8629 10.1632H12.2897C11.4899 10.1632 10.8416 9.53407 10.8416 8.75795Z"
        fill="white"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M10.8416 13.575C10.8416 12.7988 11.4899 12.1697 12.2897 12.1697H27.8629C28.6627 12.1697 29.3111 12.7988 29.3111 13.575C29.3111 14.3511 28.6627 14.9803 27.8629 14.9803H12.2897C11.4899 14.9803 10.8416 14.3511 10.8416 13.575Z"
        fill="white"
      />
    </svg>
  );
};
export const CapsiAccountLogo: React.FC<LogoProps> = ({
  active = false,
  color = "#004B8B",
  height = 54,
  width = 45,
}) => {
  return (
    <div>
      <svg
        width={width}
        height={height}
        viewBox={`0 0 ${width} ${height}`}
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M37.246 34.1935C38.0381 35.0787 37.9626 36.4385 37.0773 37.2306L22.0343 50.6906C21.2286 51.4115 20.0129 51.4223 19.1946 50.7158L13.8633 46.1132L4.4978 53.4659C3.56346 54.1994 2.21139 54.0366 1.47785 53.1023C0.744314 52.168 0.907096 50.8159 1.84143 50.0823L12.6 41.6359C13.4092 41.0007 14.555 41.0274 15.3337 41.6996L20.5747 46.2243L34.2089 34.0248C35.0942 33.2327 36.4539 33.3082 37.246 34.1935Z"
          fill={color}
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M22.9551 29.0952C22.9551 27.9073 23.918 26.9443 25.1059 26.9443H42.3278C43.5157 26.9443 44.4786 27.9073 44.4786 29.0952V45.3083C44.4786 46.4962 43.5157 47.4591 42.3278 47.4591C41.1399 47.4591 40.1769 46.4962 40.1769 45.3083V31.246H25.1059C23.918 31.246 22.9551 30.2831 22.9551 29.0952Z"
          fill={color}
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M1.0881 3.27772C2.37557 1.23388 4.7978 0 8.47651 0H36.0104C39.6907 0 42.1138 1.23342 43.401 3.27833C44.4922 5.01199 44.4885 6.97038 44.4868 7.87721C44.4868 7.91138 44.4867 7.94406 44.4867 7.97518V17.4659C44.4867 18.6583 43.4475 19.6249 42.1657 19.6249C40.8839 19.6249 39.8447 18.6583 39.8447 17.4659V7.97518C39.8447 6.97105 39.8004 6.10391 39.3951 5.46004C39.1446 5.06209 38.4901 4.31791 36.0104 4.31791H8.47651C5.99994 4.31791 5.34454 5.06163 5.09319 5.46065C4.68738 6.10486 4.64223 6.97287 4.64223 7.97518V31.3675C4.64223 32.5598 3.60309 33.5264 2.32124 33.5264C1.03939 33.5264 0.000246096 32.5598 0.000246096 31.3675V7.97518C0.000246096 7.94489 0.000189874 7.91312 0.000131217 7.87995C-0.00147355 6.97283 -0.00494091 5.01292 1.0881 3.27772Z"
          fill="black"
          fill-opacity="0.88"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M7.0929 10.6399C7.0929 9.39361 8.13401 8.3833 9.41828 8.3833H34.4255C35.7098 8.3833 36.7509 9.39361 36.7509 10.6399C36.7509 11.8862 35.7098 12.8965 34.4255 12.8965H9.41828C8.13401 12.8965 7.0929 11.8862 7.0929 10.6399Z"
          fill="black"
          fill-opacity="0.88"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M7.0929 18.3752C7.0929 17.129 8.13401 16.1187 9.41828 16.1187H34.4255C35.7098 16.1187 36.7509 17.129 36.7509 18.3752C36.7509 19.6215 35.7098 20.6318 34.4255 20.6318H9.41828C8.13401 20.6318 7.0929 19.6215 7.0929 18.3752Z"
          fill="black"
          fill-opacity="0.88"
        />
      </svg>
    </div>
  );
};
// Add remaining icons similarly from 5 to 10
